/**
 * Laadeffect voor productfoto's: zolang een foto niet binnen is, toont hij een glans (zie _loading.scss).
 * load bubbelt niet, dus via capture op het document; zo krijgen ook foto's uit filters en zoeken het effect.
 */
const SHIMMER_IMAGES = [
    '.loop-item__thumbnail img',
    '.links__block > img',
    '.tds__blocks-hero .swiper-slide img',
    '.hero_t__block-thumbnail img',
    '.wc__singleproduct-swiper-main img',
    '.wc__singleproduct-swiper-thumbs img',
    '.header__main-searched-result-thumb img',
].join(',');

export default function ($) {

    const markLoaded = (img) => {
        if (img.tagName === 'IMG' && img.matches(SHIMMER_IMAGES)) img.classList.add('is-loaded');
    };

    ['load', 'error'].forEach((type) => document.addEventListener(type, (e) => markLoaded(e.target), true));

    $(SHIMMER_IMAGES).each(function () {
        if (this.complete) markLoaded(this);
    });
}
